import { useRouter }      from "next/router";
import { useTranslation } from "react-i18next";

import { useGetDeviceType } from "_common/hooks/global";
import { shortenNumber }    from "_common/utils";
import { TextButton }       from "_components/atoms/button";
import Icon                 from "_components/atoms/icon";
import Render               from "_components/atoms/render";
import Typography           from "_components/atoms/typography";
import Chip                 from "_components/molecules/chip";
import { ProChip }          from "_components/molecules/chip/presentation";
import SharePopper          from "_components/molecules/sharePopper";
import { langArray }        from "_components/organisms/localeSelector/utils";
import useStyles            from "_styles/molecules/broadcastChips";

const component = props => {
	const {
		anchorEl,
		game,
		isProStream,
		getSrc,
		open,
		handleClickAway,
		handleClickOpen,
		isLeaderBoardLive,
		localeKey, tags, title,
		totalLikes = 0, // from videos/[id] page
		totalComments = 0, // from videos/[id] page
		onClickLike,
		isVideoLike,
		toggleCollapse,
		isFromVideos,
		onClickShareItem
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const { t }       = useTranslation ();
	const router      = useRouter ();

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet";

	const mapLang = data => {
		return data.reduce ( ( acc, item ) => {
			acc[item.locale] = item.eName;

			return acc;
		}, {} );
	};

	const checkLang = localeVal => {
		if ( !localeVal )
			return;

		const data = mapLang ( langArray );

		return data[localeVal];
	};

	const likesText = totalLikes === 0 && !isVideoLike ? "Likes" : totalLikes;

	// const onClick = ( id, name ) => {
	// if ( !id || !name )
	// return;

	// router.push ( `/game/${ id }/${ convertToSlug ( name ) }` );
	// };

	const chips = (
		<div style = { { display: "flex", flexWrap: "wrap", gap: "1rem" } }>

			<Render condition = { isProStream }>
				<ProChip
					onClick = { () => {
						router.push ( "/feed/693856?type=pro-streams" );
					} }
					title   = "Pro Stream"
				/>
			</Render>

			{
				game?.name || game?.gameName ? (
					<Chip
						buttonStyles = { `${ classes.buttonStyles } ml-none` }
						name         = { game?.name || game?.gameName }
					/>
				) : null
			}

			{
				localeKey && (
					<Chip
						buttonStyles = { classes.buttonStyles }
						name         = { checkLang ( localeKey ) }
					/>
				)
			}

			{/* Removed as Harshit said */}
			{/* {
		isLeaderBoardLive && (
			<Chip
				buttonStyles = { classes.buttonStyles }
				name = { t ( "action_giveaway" ) }
			/>
		)
	} */}

			{

				tags?.length ?
					tags.map (
						( tag, idx ) => (
							<Chip
								key          = { idx }
								buttonStyles = { classes.buttonStyles }
								name         = { tag.tagName || tag.feedTag }
							/>
						)
					) : null
			}
		</div>
	);

	if ( isMobileOrTablet ) {
		return chips;
	}

	return (
		<div className = { classes.rootContainer }>
			{chips}

			<div className = { classes.statsContainer }>

				{/* Case for Videos, Don't send Likes Count for Broadcast */}

				{isFromVideos && (
					<div className = { `${ classes.shareBtnContainer }` }
						onClick       = { onClickLike }
					>
						<Icon
							className       = { classes.svgIcon }
							name            = { isVideoLike ? "heartFilled" : "heartInactive" }
							sameInBothTheme = { isVideoLike ? true : false }
						/>

						<Typography
							className = { `${ classes.statsText }` }
							title     = { `${ shortenNumber ( isVideoLike ? ( 1 + totalLikes ) : likesText ) }` }
						/>

					</div>
				)}

				{/* Case for Videos, Don't send Comments Count for Broadcast */}

				{isFromVideos && (
					<div className = { `${ classes.shareBtnContainer }` }
						onClick       = { toggleCollapse }
					>
						<Icon
							className = { classes.svgIcon }
							name      = "comment"
						/>

						<Typography
							className = { `${ classes.statsText }` }
							title     = { totalComments ? `${ shortenNumber ( totalComments ) }` : "Comments" }
						/>

					</div>
				)}

				<TextButton
					buttonTextClassName = { classes.statsText }
					className           = { classes.shareBtn }
					leftSection         = { (
						<Icon
							name = "share"
							size = { 18 }
						/>
					) }
					onClick             = { e => handleClickOpen ( e ) }
					title               = { t ( "action_share" ) }
				/>

				<SharePopper
					useModal
					anchorEl         = { anchorEl }
					getSrc           = { getSrc }
					handleClose      = { handleClickAway }
					onClickShareItem = { onClickShareItem }
					open             = { open }
					placement        = "top-end"
					title            = { title }
				/>
			</div>

		</div>
	);
};

export default component;
